// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"cb591f1a","92":"e9b9cbfa"}[chunkId] + ".chunk.js";
};